// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "97131/static/css/" + chunkId + "." + {"591":"2e8d26bc","707":"34c622df","1566":"688aa26f"}[chunkId] + ".chunk.css";
};